/* src/app/modules/shared/components/column/column-effects/column-effects.component.scss */
app-column-effects {
  display: contents;
}
/*# sourceMappingURL=column-effects.component.css.map */
